import React from "react";

const SettingsContext = React.createContext();
export { SettingsContext };